module.exports = __webpack_public_path__ + "static/media/lameirao.ca39645f.png";